import { render, staticRenderFns } from "./ModulesDropdown.vue?vue&type=template&id=c49602c4&scoped=true"
import script from "./ModulesDropdown.vue?vue&type=script&lang=js"
export * from "./ModulesDropdown.vue?vue&type=script&lang=js"
import style0 from "./ModulesDropdown.vue?vue&type=style&index=0&id=c49602c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49602c4",
  null
  
)

export default component.exports